import { createAction, props } from '@ngrx/store';
import { Data } from './dashboard.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dashboard',
    props<{ year: number }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dashboard success', 
    props<{ listData: Data }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dashboard failure', 
    props<{ error: string }>()
);

// mark notification
export const markNotification = createAction(
    '[Data] fetch records mark notification'
);
export const markNotificationSuccess = createAction(
    '[Data] fetch records mark notification success'
);
export const markNotificationFail = createAction(
    '[Data] fetch records mark notification failure', 
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state dashboard',
);